import React, { ChangeEvent, FocusEventHandler } from "react"

import { css } from "@emotion/react"
import { Slider as MuiSlider, SliderProps as MuiSliderProps } from "@material-ui/core"

import { Box } from "../layout"
import { FieldContainer, FieldContainerProps } from "./FieldContainer"

export interface SliderProps extends FieldContainerProps {
	value?: MuiSliderProps["value"]
	onChange?: (newValue: number | number[]) => void
	min?: number
	max?: number
	marks?: MuiSliderProps["marks"]
	step?: MuiSliderProps["step"]
	valueLabelDisplay?: MuiSliderProps["valueLabelDisplay"]
	/** Format the amount in the current value bubble.  */
	valueLabelFormat?: MuiSliderProps["valueLabelFormat"]
	/**	The text that's shown beneath the slider. */
	getAriaValueText?: MuiSliderProps["getAriaValueText"]
	onBlur?: FocusEventHandler
}

export const Slider: React.FC<SliderProps> = ({
	value,
	onChange,
	min,
	max,
	marks,
	valueLabelFormat,
	getAriaValueText,
	valueLabelDisplay = "auto",
	step,
	onBlur,
	...rest
}) => {
	const handleChange = (e: ChangeEvent<{}>, newValue: number | number[]) => {
		if (onChange) {
			onChange(newValue)
		}
	}

	return (
		<FieldContainer {...rest}>
			<Box>
				<MuiSlider
					css={sliderBaseStyle}
					value={value}
					onChange={handleChange}
					valueLabelDisplay={valueLabelDisplay}
					min={min}
					max={max}
					marks={marks}
					getAriaValueText={getAriaValueText}
					valueLabelFormat={valueLabelFormat}
					step={step}
					onBlur={onBlur}
				/>
			</Box>
		</FieldContainer>
	)
}

const sliderBaseStyle = css`
	// Prevent the very first marker label from spilling out on the left.
	.MuiSlider-markLabel[data-index="0"] {
		transform: none;
	}
`
